export default [
  {
    question: `How do I earn rewards with KUJI?`,
    answer: `Simply connect your wallet and stake your KUJI. The transaction fees accumulated are paid out on a per block basis. You can choose to withdraw your rewards back to your wallet or compound the rewards.`,
  },
  {
    question: `Where does the rewards come from?`,
    answer: `All rewards come from real yield - transaction fees paid on the network by users.`,
  },
  {
    question: `Is there a lock-up period?`,
    answer: `There is a 14 days unbonding period when you want to unstake your KUJI from the network. During this period. you earn 0 rewards and will still be suspecitble to slashing.`,
  },
  {
    question: `Where can I view governance proposals for Kujira? How does voting work?`,
    answer: `You can view governance proposals here. In the event you do not vote, your vote will follow the choices of your validator, which in this case, is StakeWith.Us.`,
  },
  {
    question: `Is there a fee?`,
    answer: `There is a delegation commission fee paid to Stakewithus for staking.`,
  },
  {
    question: `Are there any risks involved with staking KUJI on unagii?`,
    answer: `Your KUJI will be staked to StakeWith.Us, a Singapore government backed staking infrastructure provider. There are slashing risks involved for downtime and double signing. Read about StakeWith.Us.`,
  },
];
